var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Plugin } from "@atlassiansox/microscopekit";
import { DnsNamesPage } from "./service/pages/dns-names";
import { DnsNamesNavigation } from "./service/navigation/dns-names-service-links";
// Microscope imports your plugin from here
var DnsNamesPlugin = /** @class */ (function (_super) {
    __extends(DnsNamesPlugin, _super);
    function DnsNamesPlugin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DnsNamesPlugin.prototype.render = function () {
        return (React.createElement(Plugin, { id: "dns-names", serviceContainer: {
                routes: [
                    {
                        path: "dns-names",
                        component: DnsNamesPage
                    }
                ],
                navigation: [
                    {
                        id: "service-navs",
                        component: DnsNamesNavigation
                    }
                ]
            } }));
    };
    return DnsNamesPlugin;
}(React.Component));
export default DnsNamesPlugin;
